import React, { memo, useState, useMemo } from "react";

import DeliveryHead from "../DeliveryHead";
import { Grid, Container, Button } from "@mui/material";
import { Formik, Form, Field, FieldArray } from "formik";
import "../../../../assets/css/datepicker.css";
import AuthInput from "../../../shared/authinput";
import MainButton from "../../../shared/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fileupload from "../../../../assets/images/fileupload.svg";
import QuoPreviewOrder from "./QuoPreviewOrder";
import CloseIcon from "@mui/icons-material/Close";
import { ImageContainer } from "../../../shared/commonstyle/ImagePreview";
import {
  RouteStepMain,
  InputFlexWrap,
  CargoDescription,
  ErrorSpan,
  FileUploadWrap,
  DateTimeWrap,
} from "../styles/QuotationOrderDetailsStyle";
import { QuotationOrderDetailsvalidation } from "../../../../helpers/validations/delivery/DeliverySteps";
import { useSelector, useDispatch } from "react-redux";
// import { SetDeliverySteps } from "../../../../redux/slice/deliverysteps/DeliveryStepsSlice";
import httpRequest from "../../../../axios/index";
import { ORDERS } from "../../../../constants/apiEndPoints";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const QuotationOrderDetails = ({ NavigateCallback }) => {
  const [BtnLoading, setBtnLoading] = useState(false);
  const DeliverySteps = useSelector((state) => state.deliverysteps.steps);
  const navigate = useNavigate();

  const [showNext, setShowNext] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const selectedImagesMemo = useMemo(() => selectedImages, [selectedImages]);

  const ShowPreviusPage = () => {
    NavigateCallback(false);
  };
  const handleImageChange = (event, arrayHelpers) => {
    const files = event.target.files;
    const fileArray = Array.from(files);

    if (selectedImages.length + fileArray.length > 3) {
      event.target.value = "";
      event.preventDefault();
      return;
    }

    arrayHelpers.push(fileArray);
    setSelectedImages((prevImages) => [...prevImages, ...fileArray]);
  };

  const handleRemoveImage = (index, setFieldValue) => {
    const updatedImages = [...selectedImages];
    updatedImages.splice(index, 1);
    setSelectedImages(updatedImages);
    setFieldValue("CargoImages", updatedImages);
  };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setBtnLoading(true);
      const formData = new FormData();
      formData.append(
        "order[stops_attributes][0][contact_name]",
        DeliverySteps?.pickup?.ContactName
      );
      formData.append(
        "order[stops_attributes][0][phone_number]",
        DeliverySteps?.pickup?.phoneNumber
      );
      formData.append(
        "order[stops_attributes][0][email]",
        DeliverySteps?.pickup?.phoneNumber
      );
      formData.append("order[stops_attributes][0][stop_type]", "pickup");
      formData.append("order[stops_attributes][0][notes]", "Notes for pickup");
      formData.append(
        "order[stops_attributes][0][order_detail_attributes][name]",
        values?.CargoName
      );
      formData.append(
        "order[stops_attributes][0][order_detail_attributes][weight]",
        values?.WidthLbs
      );
      formData.append(
        "order[stops_attributes][0][order_detail_attributes][length]",
        values?.Length
      );
      formData.append(
        "order[stops_attributes][0][order_detail_attributes][width]",
        values?.WidthIn
      );
      formData.append(
        "order[stops_attributes][0][order_detail_attributes][height]",
        values?.HeightIn
      );
      formData.append(
        "order[stops_attributes][0][order_detail_attributes][datetime]",
        values?.DateTime
      );
      formData.append(
        "order[stops_attributes][0][order_detail_attributes][description]",
        values?.CargoDescription
      );
      const images = selectedImagesMemo;
      for (let i = 0; i < images.length; i++) {
        formData.append(
          "order[stops_attributes][0][order_detail_attributes][images][]",
          images[i]
        );
      }
      formData.append(
        "order[stops_attributes][0][location_attributes][longitude]",
        DeliverySteps?.pickup?.Location?.lng || ""
      );
      formData.append(
        "order[stops_attributes][0][location_attributes][latitude]",
        DeliverySteps?.pickup?.Location?.lat || ""
      );

      formData.append(
        "order[stops_attributes][1][contact_name]",
        DeliverySteps?.dropoff?.ContactName || ""
      );
      formData.append(
        "order[stops_attributes][1][phone_number]",
        DeliverySteps?.dropoff?.phoneNumber || ""
      );
      formData.append(
        "order[stops_attributes][1][email]",
        DeliverySteps?.dropoff?.EmailAddress || ""
      );
      formData.append("order[stops_attributes][1][stop_type]", "dropoff");
      formData.append("order[stops_attributes][1][notes]", "test");
      formData.append(
        "order[stops_attributes][1][location_attributes][longitude]",
        DeliverySteps?.dropoff?.Location?.lng || ""
      );
      formData.append(
        "order[stops_attributes][1][location_attributes][latitude]",
        DeliverySteps?.dropoff?.Location?.lat || ""
      );

      const resp = await httpRequest.post(ORDERS, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (resp?.status === 200) {
        if (resp?.data.message === "Success") {
          const order_id = resp?.data?.data?.order_id;
          navigate(`/delivery-steps/?id=${order_id}`);
          setShowNext(true);
          setSelectedImages([]);
          resetForm();
          toast.success("added successfully");
        }
      }
      setBtnLoading(false);
    } catch (error) {
      // Handle error
      toast.error(error?.response?.data?.message || "Something went wrong");
      setBtnLoading(false);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      {!showNext ? (
        <>
          <DeliveryHead
            Value={100}
            BackLink="/delivery-details"
            CenterText="Order Details"
            StepText="3 of 3"
            MobileMainText="Order Details"
            MobileSubText="Next: Preview"
            MobileMoreText={true}
            haveCallBack={true}
            CallBackFun={ShowPreviusPage}
          />
          <RouteStepMain className="customer__dateinputs">
            <Container maxWidth="lg">
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12} md={10} lg={8}>
                  <Formik
                    initialValues={{
                      CargoName: "",
                      WidthLbs: "",
                      WidthIn: "",
                      HeightIn: "",
                      Length: "",
                      CargoImages: [],
                      DateTime: "",
                      CargoDescription: "",
                    }}
                    validationSchema={QuotationOrderDetailsvalidation}
                    onSubmit={handleSubmit}
                  >
                    {(formik) => (
                      <Form autocomplete="off">
                        <InputFlexWrap>
                          <InputFlexWrap className="CargoNameFlexWrap">
                            <Field
                              type="text"
                              name="CargoName"
                              label="Cargo"
                              component={AuthInput}
                              placeholder="Enter cargo name"
                            />
                            <Field
                              type="number"
                              name="WidthLbs"
                              label="Weight"
                              component={AuthInput}
                              placeholder="Weight"
                              inputMoreText="Lbs"
                              haveMoreText={true}
                            />
                          </InputFlexWrap>

                          <InputFlexWrap className="DimensionsFlexWrap">
                            <Field
                              type="number"
                              name="Length"
                              label="Dimensions"
                              component={AuthInput}
                              placeholder="Length"
                              inputMoreText="In"
                              haveMoreText={true}
                            />
                            <Field
                              type="number"
                              name="WidthIn"
                              label=""
                              component={AuthInput}
                              placeholder="Width"
                              inputMoreText="In"
                              haveMoreText={true}
                              nolabel={true}
                            />
                            <Field
                              type="number"
                              name="HeightIn"
                              label=""
                              component={AuthInput}
                              placeholder="Height"
                              inputMoreText="In"
                              haveMoreText={true}
                              nolabel={true}
                            />
                          </InputFlexWrap>
                        </InputFlexWrap>

                        {/* image and date time  */}

                        <InputFlexWrap>
                          <FileUploadWrap>
                            <label>Cargo Image</label>
                            <Button
                              variant="contained"
                              component="label"
                              className="ButtonContainer"
                              disabled={selectedImages.length >= 3}
                            >
                              <span className="ButtonLabel">
                                Add your cargo image
                                <img src={fileupload} alt="fileupload" />
                              </span>
                              <FieldArray name="CargoImages">
                                {(arrayHelpers) => (
                                  <input
                                    type="file"
                                    accept="image/*"
                                    hidden
                                    onChange={(event) =>
                                      handleImageChange(event, arrayHelpers)
                                    }
                                  />
                                )}
                              </FieldArray>
                            </Button>

                            {formik.touched.CargoImages &&
                              formik.errors.CargoImages && (
                                <ErrorSpan className="errorSpan">
                                  {formik.errors.CargoImages}
                                </ErrorSpan>
                              )}
                          </FileUploadWrap>
                          <DateTimeWrap>
                            <label>Date & Time</label>
                            <DatePicker
                              selected={formik.values.DateTime}
                              onChange={(date) =>
                                formik.setFieldValue("DateTime", date)
                              }
                              showTimeSelect
                              timeFormat="HH:mm"
                              timeIntervals={15}
                              dateFormat="MM/dd/yyyy h:mm aa"
                              placeholderText="Select pickup date & time"
                              className="form-control"
                            />
                            {formik.touched.DateTime &&
                              formik.errors.DateTime && (
                                <ErrorSpan className="errorSpan">
                                  {formik.errors.DateTime}
                                </ErrorSpan>
                              )}
                          </DateTimeWrap>
                        </InputFlexWrap>
                        {/* End image and date time  */}

                        {/* Cargo Description */}

                        <CargoDescription
                          className={
                            formik.errors.CargoDescription ? "haveBorder" : ""
                          }
                        >
                          <label>Cargo Description</label>
                          <Field
                            as="textarea"
                            name="CargoDescription"
                            placeholder="Enter cargo description"
                          />

                          {formik.touched.CargoDescription &&
                            formik.errors.CargoDescription && (
                              <ErrorSpan>
                                {formik.errors.CargoDescription}
                              </ErrorSpan>
                            )}
                        </CargoDescription>

                        {/*End Cargo Description */}

                        {/* show the images */}
                        {selectedImagesMemo &&
                          selectedImagesMemo.length > 0 && (
                            <ImageContainer className="ImageContainer">
                              {selectedImagesMemo?.map((file, index) => (
                                <div
                                  key={index}
                                  className="ImageItem"
                                  // style={{
                                  //   backgroundImage: `url(${URL.createObjectURL(
                                  //     file
                                  //   )})`,
                                  // }}
                                >
                                  <img
                                    src={URL.createObjectURL(file)}
                                    alt="oredr images"
                                  />
                                  <CloseIcon
                                    className="RemoveIcon"
                                    onClick={() =>
                                      handleRemoveImage(
                                        index,
                                        formik.setFieldValue
                                      )
                                    }
                                  />
                                </div>
                              ))}
                            </ImageContainer>
                          )}
                        {/* End show the images */}

                        <MainButton
                          type="submit"
                          label="Request a Delivery"
                          MT="110"
                          isLoading={BtnLoading}
                        />
                      </Form>
                    )}
                  </Formik>
                </Grid>
              </Grid>
            </Container>
          </RouteStepMain>
        </>
      ) : (
        <QuoPreviewOrder NavigateCallback={setShowNext} />
      )}
    </>
  );
};

export default memo(QuotationOrderDetails);
